import { render, staticRenderFns } from "./PlayerRegistrationFormConfirmation.vue?vue&type=template&id=cb7e86b8&scoped=true&"
import script from "./PlayerRegistrationFormConfirmation.vue?vue&type=script&lang=js&"
export * from "./PlayerRegistrationFormConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./PlayerRegistrationFormConfirmation.vue?vue&type=style&index=0&id=cb7e86b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7e86b8",
  null
  
)

export default component.exports